import type { RouteObject } from 'react-router-dom';

import { values } from 'lodash-es';

import type { LookoRouteObject } from '../LookoRouteObject';

const 데모_라우터 = {
  업로드: {
    path: '/demo/upload',
    async lazy() {
      const { default: Page } = await import('@/router/demo/데모_업로드_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: 'AI 상품 업로드 체험',
      analytics: {
        screen_name: '상품 업로드 체험_상품 이미지 선택',
      },
    },
  } satisfies LookoRouteObject,

  상품_분석_완료: {
    path: '/demo/upload/result/:taskID',
    async lazy() {
      const { default: Page } = await import('@/router/demo/상품_분석_완료_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: 'AI 상품 업로드 체험',
      analytics: {
        screen_name: '상품 업로드 체험_상품 이미지 분석 완료',
      },
    },
  } satisfies LookoRouteObject,
};

export const 데모_라우터_루트: RouteObject = {
  async lazy() {
    const { default: Page } = await import('@/router/demo/DemoRouteLayout');
    return {
      Component: Page,
    };
  },
  children: [...values(데모_라우터)],
};
